var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8846 0C25.5965 0 27 1.40355 27 3.11538V23.8846C27 25.5965 25.5965 27 23.8846 27H3.11538C1.40355 27 0 25.5965 0 23.8846V3.11538C0 1.40355 1.40355 0 3.11538 0H23.8846ZM23.8846 2.07692H3.11538C2.53125 2.07692 2.07692 2.53125 2.07692 3.11538V23.8846C2.07692 24.4688 2.53125 24.9231 3.11538 24.9231H23.8846C24.4688 24.9231 24.9231 24.4688 24.9231 23.8846V3.11538C24.9231 2.53125 24.4688 2.07692 23.8846 2.07692ZM14.5385 6.23077V12.4615H6.23077V6.23077H14.5385ZM20.7692 8.30769V10.3846H16.6154V8.30769H20.7692ZM12.4615 8.30769H8.30769V10.3846H12.4615V8.30769ZM14.5385 14.5385V20.7692H6.23077V14.5385H14.5385ZM20.7692 16.6154V18.6923H16.6154V16.6154H20.7692ZM12.4615 16.6154H8.30769V18.6923H12.4615V16.6154Z",
    fill: "#01A6C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpi);
export default __webpack_public_path__ + "static/media/MPI.80d4bb306d1dcbfc1b40447a8c6208bf.svg";
export { ForwardRef as ReactComponent };